/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable unused-imports/no-unused-vars */
import { Box } from "@mui/material";
import Pagination from "../pagination/pagination";
import PageNavigator from "../page-navigator/page-navigator";
import "./footer.scss";
import { IPaginationModel } from "../../@types/pagination-model";
import React, { useEffect, useState } from "react";

interface IFooter {
  pages: any;
  setPages: any;
  currentPage: string | number;
  setCurrentPage: any;
  total: number;
  paginationModel: IPaginationModel;
  handlePaginationModel: (model: IPaginationModel) => void;
  sharedPages: any;
  resource: string;
  savePageConfiguration: () => void;
  handlePageDelete: (pages: any[]) => void;
  enablePages: boolean
  isPaginationDisplayed?: boolean
  isPageSaving?: boolean
}

const Footer = React.memo(({
  pages,
  setPages,
  currentPage,
  setCurrentPage,
  total, // total number of pages in footer pagination
  paginationModel,
  handlePaginationModel,
  sharedPages,
  resource,
  savePageConfiguration,
  handlePageDelete,
  enablePages,
  isPaginationDisplayed = true,
  isPageSaving = false
}: IFooter) => {
   const [isDrawerOpen, setIsDrawerOpen] = useState(
    window.localStorage.getItem('_is_drawer_open') === 'true'
  );

  useEffect(() => {
    const handleStorageChange = () => {
      setIsDrawerOpen(window.localStorage.getItem('_is_drawer_open') === 'true');
    };

    window.addEventListener('storage', handleStorageChange);

    const interval = setInterval(handleStorageChange, 10); 

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  // useEffect(()=>{
  //   handlePaginationModel({...paginationModel,pageNo:activePage?.pageNo})
  //   //eslint-disable-next-line react-hooks/exhaustive-deps
  // },[activePage?.pageNo])

  return (
    <Box className={`${!isDrawerOpen?'footer--drawerContainer':'footer--Container'}`} sx={{justifyContent: enablePages? 'space-between': 'flex-end'}}>
      
       
        {Boolean(enablePages) && <PageNavigator
          pages={pages}
          setPages={setPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          resource={resource}
          sharedPages={sharedPages}
          handlePageDelete={handlePageDelete}
        />}
      <Box>
        {isPaginationDisplayed && (
          <Pagination
            paginationModel={paginationModel}
            handlePaginationModel={handlePaginationModel}
            totalPages={total}
          />
        )}
      </Box>
    </Box>
  );
});

export { Footer };
export default Footer;
